<script lang="ts">
	import { internalGetFailedSnippet } from "./RouteGroup.svelte";
	import { getCurrentRouteGroup } from "./lib.svelte";

	interface Props {
		pattern: URLPatternInput;
		page: () => Promise<typeof import("./internal/TypeHack.svelte")>;
	}

	const { pattern, page }: Props = $props();

	const ctx = getCurrentRouteGroup();
	const failed = internalGetFailedSnippet();

	// svelte-ignore state_referenced_locally
	const matches = ctx.internalAdd(pattern);
</script>

{#if $matches}
	{const { default: Component } = await page()}

	<svelte:boundary {failed}>
		<Component params={$matches}></Component>
	</svelte:boundary>
{/if}
